export default "__VITE_ASSET__B93nuCDQ__"